export default __webpack_public_path__ + "static/media/GD.21e630a4.png";